import { supabase } from '@/lib/supabase';

type CreateTrackingReportInput = {
  projectId: number;
  description: string;
  kpiValues: Record<number, string>;
  documentIds: number[];
};

export const createTrackingReport = async (
  input: CreateTrackingReportInput,
): Promise<number> => {
  const { projectId, description, kpiValues, documentIds } = input;

  const kpiEntries = Object.entries(kpiValues)
    .filter(([, value]) => value.trim() !== '')
    .map(([kpiId, value]) => ({
      kpi_id: parseInt(kpiId),
      value: parseFloat(value) || 0,
    }));

  const { data: reportId, error } = await supabase.rpc(
    'create_tracking_report',
    {
      p_project_id: projectId,
      p_description: description,
      p_kpi_entries: kpiEntries,
      p_document_ids: documentIds,
    },
  );

  if (error) {
    throw error;
  }

  return reportId;
};
